import React from 'react'


import {locale} from '../locale/AppLocale'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import {Field} from 'redux-form'
import ProductInput from '../Components/ProductInput'

const checkBoxInput = ({input, id, type}) => {
    return (
        <input
            {...input}
            id={id}
            type={type}/>
    );
};
const inputMessage = ({meta}) => {
    return (
        <div className={` input-c  ` + (meta.error ? 'has-error ' : '')}>
            {meta.touched
            && ((meta.error &&
            <div className="has-error"><span className="help-block is-error">{meta.error}</span></div> )
            || (meta.warning && <span>{meta.warning}</span>))}
        </div>
    )
}

export default class WithoutVariantFields extends React.Component {

    constructor(props) {
        super(props);
        this.hasSelfShipping = this.hasSelfShipping.bind(this);
        this.canShippingToRegion = this.canShippingToRegion.bind(this);
        this.getSelectedAddress = this.getSelectedAddress.bind(this);
    }

    getSelectedAddress(){
        const pickupFrom = parseInt(this.props.selector('pickup_from'), 10);
        const addresses = this.props.addresses;
        if(!pickupFrom || !addresses){
            return false;
        }
        let index = addresses.findIndex((address) => {
            return address.id === pickupFrom;
        });
        if (!addresses[index]) {
            return false;
        }
        return addresses[index];
    }
    hasSelfShipping() {
        const selectedAddress = this.getSelectedAddress();
        if (!selectedAddress) {
            return false;
        }

        return selectedAddress.can_shipping_products || false;
    }
    canShippingToRegion(regionLocation) {
        const selectedAddress = this.getSelectedAddress();

        if (!selectedAddress || !selectedAddress['can_shipping_to_region']) {
            return false;
        }
        if(!selectedAddress['can_shipping_to_region'][regionLocation]){
            return false;
        }
        return selectedAddress['can_shipping_to_region'][regionLocation];
    }
    render() {

        return (
            <div>

                { this.props.only_primary !== true &&
                <div className="tooltip-field" data-scroll-hide={true}
                     data-event="click focusin focus" data-event-off="focusout" data-tip=''
                     data-tooltip-id='tooltip_quantity' data-iscapture="false" data-place="left"
                     data-effect="solid" data-multiline="true">
                    <Field
                        type="text"
                        name="quantity"
                        id="quantity"
                        component={ProductInput}
                        className="form-control"
                        label={locale.get('quantity')}
                        placeholder={locale.get('quantity')}
                        field={{}}/>
                    <ReactTooltip
                        id='tooltip_quantity'>{locale.get('sell_product_tooltip_quantity')}</ReactTooltip>
                </div> }
                { this.props.only_primary !== true &&
                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                     data-event="click focusin focus" data-event-off="focusout"
                     data-tooltip-id='tooltip_price' data-iscapture="false" data-place="left"
                     data-effect="solid" data-multiline="true">
                    <Field
                        type="text"
                        name="price"
                        id="price"
                        component={ProductInput}
                        className="form-control"
                        label={locale.get('price')}
                        placeholder={locale.get('price')}
                        field={{}}/>
                    <ReactTooltip
                        id='tooltip_price'>{locale.get('sell_product_tooltip_price')}</ReactTooltip>
                </div>
                }
                { this.props.only_primary !== true &&
                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                     data-event="click focusin focus" data-event-off="focusout"
                     data-tooltip-id='tooltip_sku' data-iscapture="false" data-place="left"
                     data-effect="solid" data-multiline="true">
                    <Field
                        type="text"
                        name="sku"
                        id="sku"
                        component={ProductInput}
                        className="form-control"
                        label={locale.get('sku')}
                        placeholder={locale.get('sku')}
                        field={{}}/>
                    <ReactTooltip
                        id='tooltip_sku'>{locale.get('sell_product_tooltip_sku')}</ReactTooltip>
                </div>
                }

                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                     data-event="click focusin focus" data-event-off="focusout"
                     data-tooltip-id='tooltip_notes' data-iscapture="true" data-place="left"
                     data-effect="solid" data-multiline="true">
                    <Field
                        type="textarea"
                        name="notes"
                        id="notes"
                        component={ProductInput}
                        className="form-control"
                        label={locale.get('seller_notes')}
                        placeholder={locale.get('seller_notes')}
                        field={{}}/>
                    <ReactTooltip
                        id='tooltip_notes'>{locale.get('sell_product_tooltip_notes')}</ReactTooltip>
                </div>

                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                     data-event="click" data-event-off="focusout"
                     data-tooltip-id='tooltip_handling_time' data-iscapture="true" data-place="left"
                     data-effect="solid" data-multiline="true">
                    <Field
                        name="handling_time"
                        id="handling_time"
                        component={ProductInput}
                        className="form-control"
                        label={locale.get('handling_time')}
                        placeholder={locale.get('handling_time')}
                        field={{data_type: "dropdown", options: this.props.handling_times}}/>
                    <ReactTooltip
                        id='tooltip_handling_time'>{locale.get('sell_product_tooltip_handling_time')}</ReactTooltip>
                </div>

                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                     data-event="click" data-event-off="focusout"
                     data-tooltip-id='tooltip_product_condition' data-iscapture="true" data-place="left"
                     data-effect="solid" data-multiline="true">
                    <Field
                        name="pcondition"
                        id="pcondition"
                        component={ProductInput}
                        className="form-control"
                        ref="hand"
                        label={locale.get('product_condition')}
                        placeholder={locale.get('product_condition')}
                        field={{data_type: "dropdown", options: this.props.product_conditions || [] }}/>

                    <ReactTooltip
                        id='tooltip_product_condition'>{locale.get('sell_product_product_condition')}</ReactTooltip>
                </div>

                <div className="addresses-list ">
                    <div className="label">{locale.get('pickup_from')}</div>
                    <div className="">
                        {this.props.addresses.map((address, index) => {
                            let isChecked = parseInt(this.props.selector('pickup_from'), 0) === parseInt(address.id, 0);
                            /*isChecked = isChecked || this.props.addresses.length === 1*/


                            return (
                                <div key={index}
                                     className={`${isChecked ? 'is-active' : ''} address--item`}
                                     htmlFor={`pickup_from-` + address.id}>
                                    <label htmlFor={`pickup_from-` + address.id}>
                                        <Field
                                            type="radio"
                                            name={`pickup_from`}
                                            id={`pickup_from-` + address.id}
                                            component={checkBoxInput}
                                            className="form-control"
                                            defaultChecked={isChecked}
                                            value={address.id.toString()}
                                            field={{}}
                                        />
                                        <strong className="address--item--name">{address.name}</strong>
                                        <div className="address--item--address">{address.address_1}</div>
                                        <div className="address--item--address">{address.address}</div>
                                        <div className="address--item--phone">{address.phone}</div>
                                    </label>
                                </div>
                            );
                        })}
                        <Field name={`pickup_from`} component={inputMessage}/>
                    </div>
                </div>

                {
                    this.hasSelfShipping() ? <div >
                        <Field
                            type="checkbox"
                            name="shipping_by_seller"
                            id="shipping_by_seller"
                            component={ProductInput}
                            className="form-control"
                            label={locale.get('shipper')}
                            alt_label={locale.get('shipping_by_seller')}
                            field={{}}/>
                        <ReactTooltip
                            id='tooltip_shipping_by_seller'>{locale.get('sell_product_tooltip_shipping_by_seller')}</ReactTooltip>
                    </div>
                        : ''
                }
                <div className="clearfix"/>
                {/*<div >*/}
                {/*    <Field*/}
                {/*        name="shipping_delivery_option"*/}
                {/*        id="shipping_delivery_option"*/}
                {/*        component={ProductInput}*/}
                {/*        className="form-control"*/}
                {/*        ref="hand"*/}
                {/*        label={locale.get('shipping_delivery_option')}*/}
                {/*        placeholder={locale.get('shipping_delivery_option')}*/}
                {/*        field={{data_type: "dropdown", options: this.props.shipping_delivery_options_list || [] }}/>*/}

                {/*</div>*/}
                <div className="clearfix"/>
                {/*{*/}
                {/*    this.getSelectedAddress() ? <div className="alert alert-warning mb-30 text-right">{locale.get('free_shipping_notification_message')}</div> : ''*/}
                {/*}*/}
                {/*<div className="clearfix"/>*/}

                {/*<div className="tooltip-field" data-tip='' data-scroll-hide={true}*/}
                {/*     data-event="click focusin focus" data-event-off="focusout"*/}
                {/*     data-tooltip-id='tooltip_free_shipping' data-iscapture="false" data-place="left"*/}
                {/*     data-effect="solid" data-multiline="true">*/}

                {/*    {*/}
                {/*        this.canShippingToRegion('westbank') ? <Field*/}
                {/*            type="checkbox"*/}
                {/*            name="free_shipping"*/}
                {/*            id="free_shipping"*/}
                {/*            component={ProductInput}*/}
                {/*            className="form-control"*/}
                {/*            label={locale.get('shipping_to_westbank')}*/}
                {/*            alt_label={locale.get('free_shipping')}*/}
                {/*            field={{}}/>*/}
                {/*            : ''*/}
                {/*    }*/}
                {/*    {*/}
                {/*        this.canShippingToRegion('jerusalem') ? <Field*/}
                {/*            type="checkbox"*/}
                {/*            name="free_shipping_jerusalem"*/}
                {/*            id="free_shipping_jerusalem"*/}
                {/*            component={ProductInput}*/}
                {/*            className="form-control"*/}
                {/*            label={locale.get('shipping_to_jerusalem')}*/}
                {/*            alt_label={locale.get('free_shipping_jerusalem')}*/}
                {/*            field={{}}/>*/}
                {/*            : ''*/}
                {/*    }*/}
                {/*    {*/}
                {/*        this.canShippingToRegion('48_area') ? <Field*/}
                {/*            type="checkbox"*/}
                {/*            name="free_shipping_48"*/}
                {/*            id="free_shipping_48"*/}
                {/*            component={ProductInput}*/}
                {/*            className="form-control"*/}
                {/*            label={locale.get('shipping_to_48_area')}*/}
                {/*            alt_label={locale.get('free_shipping_48')}*/}
                {/*            field={{}}/>*/}
                {/*            : ''*/}
                {/*    }*/}
                {/*    {*/}
                {/*        this.canShippingToRegion('gaza') ? <Field*/}
                {/*            type="checkbox"*/}
                {/*            name="free_shipping_gaza"*/}
                {/*            id="free_shipping_gaza"*/}
                {/*            component={ProductInput}*/}
                {/*            className="form-control"*/}
                {/*            label={locale.get('shipping_to_gaza')}*/}
                {/*            alt_label={locale.get('free_shipping_gaza')}*/}
                {/*            field={{}}/>*/}
                {/*            : ''*/}
                {/*    }*/}

                {/*    <ReactTooltip*/}
                {/*        id='tooltip_free_shipping'>{locale.get('sell_product_tooltip_free_shipping')}</ReactTooltip>*/}
                {/*</div>*/}

            </div>
        )

    }

}